import { get } from "lodash";

export default function(value) {
  return Boolean(get(value, "value"));
}
